import React, { useEffect, useState } from "react";
import { useScroll } from "framer-motion";
import Twitter from "../assets/images/twitter-black.svg"
import HomeIcon from "../assets/images/moca-home.svg";
import Modal from "../components/Modal";

function Header() {
  const [showDesktopNav, setShowDesktopNav] = useState({ display: true, y: 0 });
  const { scrollY } = useScroll({});

  useEffect(() => {
    scrollY.onChange((latest) => {

      if (latest <= showDesktopNav.y) {
        setShowDesktopNav({ display: true, y:latest});
      } else {
        setShowDesktopNav({ display: false });
        return;
      }
    });
  }, [scrollY, setShowDesktopNav, showDesktopNav]);

  return (
    <>
      <header>
        <DesktopNav showDesktopNav={showDesktopNav} />
        <div
          className="menu-shrink-desktop"
          onClick={() =>
            setShowDesktopNav({ display: true, y: scrollY.latest })
          }
        ></div>
        <MobileNav />
      </header>
    </>
  );
}

function DesktopNav({ showDesktopNav, address }) {

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (address) {
      setShowModal(false);
    }
  }, [address]);

  return (
    <>
      {showModal && <Modal toggleModal={() => setShowModal(false)} />}
      <nav
        style={{
          position: showDesktopNav.display && "fixed",
          display: showDesktopNav.display ? "flex" : "none",
          zIndex: 1100,
          margin: "0 auto",
          left: 0,
          right: 0,
        }}
      >
        <div className="desktop">
          <li>
            <a href="#home" className="home" onClick={() => showDesktopNav({ display: true })}>
              <img src={HomeIcon} alt="Mocaverse" />
            </a>
          </li>
          <li>
            <a href="#story-of-mocas">Story of The Mocas</a>
          </li>
          <li>
            <a href="#realms">Realms</a>
          </li>
          <li>
            <a href="#what-is-mocaverse">What is Mocaverse?</a>
          </li>
          <li>
            <a href="#faq">FAQ</a>
          </li>
          <li>
            <div className="connect btn" onClick={() => setShowModal(true)}>
            Get Updates
            </div>
          </li>
        </div>
      </nav>
    </>
  );
}

function MobileNav({ address }) {
  const [isActive, setIsActive] = useState(false);
  const handleClick = (event) => {
    setIsActive((current) => !current);
  };

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && <Modal toggleModal={() => setShowModal(false)} />}
      <nav>
        <div className={!isActive ? "mobile close" : " mobile open"}>
          <div
            className={!isActive ? "mobile-btn close" : " mobile-btn open"}
            onClick={handleClick}
          >
            <img src={HomeIcon} className="mobile-moca-icon" alt="" />
            <span>Mocaverse</span>
          </div>
          <li>
          <div className="connect btn" onClick={() => setShowModal(true)}>
          Get Updates
            </div>
          </li>
          <div className="mobile-nav">
            <ul>
            <li>
              <a href="#home" onClick={handleClick}><span className="icon"/> Mocaverse</a>
            </li>
            <li>
              <a href="#story-of-mocas" onClick={handleClick}>Story of The Mocas</a>
            </li>
            <li>
              <a href="#realms" onClick={handleClick} >Realms</a>
            </li>
            <li>
              <a href="#what-is-mocaverse" onClick={handleClick}>What is Mocaverse?</a>
            </li>
            <li className="last">
              <a href="#faq" onClick={handleClick}>FAQ</a>
            </li>
            </ul>
            <div className="social-btn">
              <ul>
                <li>
                  <a
                    href="https://twitter.com/MocaverseNFT"
                    className="socials"
                    target="_blank"
                    without
                    rel="noreferrer"
                  >
                    <img src={Twitter} alt="Twitter" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="navBg"></div>
          <div className="navoverlay" onClick={handleClick}></div>
        </div>
      </nav>
    </>
  );
}

export default Header;
